<template>
  <a
    :href="href"
    :class="[classes, customButtonClass]"
    :style="styles"
    @click="onClick"
  >
    <slot />
  </a>
</template>

<script>

export default {
  name: 'c-button',
  props: {
    name: {
      type: String,
      default: null,
    },
    href: {
      type: String,
      default: '#',
    },
    bgColor: {
      type: String,
      default: '#074E8E',
    },
    borderColor: {
      type: String,
      default: 'transparent',
    },
    fontColor: {
      type: String,
      default: '#FFFFFF',
    },
    radius: {
      type: Number,
      default: 0,
    },
    vertical: {
      type: Boolean,
      default: false,
    },
    weight: {
      type: String,
      default: '400',
      description: '(100-800 / bolder / lighter / normal)'
    },
    useCustomButton: {
      type: String,
      default: null,
      description: '(primary / secondary / tertiary / reversePrimary / reverseSecondary / reverseTertiary)'
    },
    experience: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    classes() {
      return ['c-button', { 'c-button--vertical': this.vertical, 'c-button--experience': this.experience }]
    },
    styles() {
      return {
        backgroundColor: this.bgColor,
        borderColor: this.borderColor,
        color: this.fontColor,
        borderRadius: `${this.radius}px`,
        fontWeight: this.weight
      }
    },
    customButtonClass() {
      if (this.useCustomButton) {
        return `c-button--${this.useCustomButton}`
      }
      return ''
    },
  },
  mounted() {
    this.updateRadius()
  },
  methods: {
    updateRadius() {
      if (this.radius < 100) return

      const { clientWidth, clientHeight } = this.$el

      if (clientWidth > clientHeight) {
        this.$el.style.height = `${clientWidth}px`
      } else if (clientWidth < clientHeight) {
        this.$el.style.width = `${clientHeight}px`
      }
    },
  },
}
</script>

<style lang="scss" scoped>
  .c-button {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    position: relative;
    padding: 0.75rem 1.25rem;
    gap: 1rem;
    overflow: hidden;
    cursor: pointer;
    text-decoration: none;
    border: 2px solid transparent;
    text-align: center;
    transition: all 0.3s ease;

    &--vertical {
      flex-direction: column;
    }

    & > * {
      margin: 0.225rem;
      z-index:1;
    }

    &::before {
      content: '';
      opacity: 0.1;
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      transition: all 0.3s;
    }

    &--experience {
      &::before {
        content: unset;
      }
    }

    &:hover {
      &::before {
        opacity: 0.1;
      }
    }

    @include defaultButtons();
    @include weight();
  }

</style>
